import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private config: any;

  constructor(
    private http: HttpClient
  ) { }

  loadConfig() {
    return this.http.get('/assets/configuration/configuration.json')
      .toPromise()
      .then((data: any) => {
        this.config = data;
      });
  }

  get setting() {
    return this.config;
  }
}